// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import PhotoSheetProductBox from "./photo-sheet-product-box.js"
import PhotoSheetProductSheetLayout from "./photo-sheet-product-sheet-layout.js"
import SheetLayout from "./sheet-layout.js"
import Tenant from "./tenant.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "digital_product": {
      "column": {
        "default": false,
        "name": "digital_product",
        "null": false,
        "type": "boolean"
      },
      "name": "digital_product",
      "selected_by_default": null,
      "translated": false
    },
    "global": {
      "column": {
        "default": false,
        "name": "global",
        "null": false,
        "type": "boolean"
      },
      "name": "global",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "photo_sheet_product_sheet_layouts_count": {
      "column": {
        "default": 0,
        "name": "photo_sheet_product_sheet_layouts_count",
        "null": false,
        "type": "integer"
      },
      "name": "photo_sheet_product_sheet_layouts_count",
      "selected_by_default": null,
      "translated": false
    },
    "sheet_layout_id": {
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      },
      "name": "sheet_layout_id",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    }
  },
  "className": "PhotoSheetProduct",
  "collectionKey": "photo_sheet_products",
  "collectionName": "photo_sheet_products",
  "i18nKey": "photo_sheet_product",
  "camelizedLower": "photoSheetProduct",
  "name": "PhotoSheetProduct",
  "nameDasherized": "photo-sheet-product",
  "pluralName": "photo_sheet_products",
  "ransackable_associations": [
    {
      "className": "PhotoSheetProduct::Translation",
      "collectionName": null,
      "foreignKey": "photo_sheet_product_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "TenantShopSetting",
      "collectionName": "tenant_shop_settings",
      "foreignKey": "default_tenant_photo_sheet_product_id",
      "name": "default_tenant_photo_sheet_product_on_tenant_shop_settings",
      "macro": "has_many",
      "resource_name": "TenantShopSetting",
      "through": "tenant_photo_products"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoProduct",
      "collectionName": "photo_products",
      "foreignKey": "resource_id",
      "name": "photo_products",
      "macro": "has_many",
      "resource_name": "PhotoProduct",
      "through": null
    },
    {
      "className": "PhotoSheetProductBox",
      "collectionName": "photo_sheet_product_boxes",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product_boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductBox",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product_order_lines",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "PhotoSheetProductSheetLayout",
      "collectionName": "photo_sheet_product_sheet_layouts",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product_sheet_layouts",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductSheetLayout",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantPhotoProduct",
      "collectionName": "tenant_photo_products",
      "foreignKey": "photo_product_id",
      "name": "tenant_photo_products",
      "macro": "has_many",
      "resource_name": "TenantPhotoProduct",
      "through": "photo_products"
    },
    {
      "className": "PhotoSheetProduct::Translation",
      "collectionName": null,
      "foreignKey": "photo_sheet_product_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "digital_product",
      "column": {
        "default": false,
        "name": "digital_product",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "global",
      "column": {
        "default": false,
        "name": "global",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_sheet_product_sheet_layouts_count",
      "column": {
        "default": 0,
        "name": "photo_sheet_product_sheet_layouts_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "sheet_layout_id",
      "column": {
        "default": null,
        "name": "sheet_layout_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "PhotoSheetProductBox",
      "collectionName": "photo_sheet_product_boxes",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product_boxes",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductBox",
      "through": null
    },
    {
      "className": "PhotoSheetProductSheetLayout",
      "collectionName": "photo_sheet_product_sheet_layouts",
      "foreignKey": "photo_sheet_product_id",
      "name": "photo_sheet_product_sheet_layouts",
      "macro": "has_many",
      "resource_name": "PhotoSheetProductSheetLayout",
      "through": null
    },
    {
      "className": "SheetLayout",
      "collectionName": "sheet_layouts",
      "foreignKey": "sheet_layout_id",
      "name": "sheet_layout",
      "macro": "belongs_to",
      "resource_name": "SheetLayout",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    }
  ],
  "paramKey": "photo_sheet_product",
  "primaryKey": "id"
}

/** Frontend model for PhotoSheetProduct. */
export default class PhotoSheetProduct extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  digitalProduct() {
    return this.readAttributeUnderscore("digital_product")
  }

  /** @returns {boolean} */
  hasDigitalProduct() {
    const value = this.digitalProduct()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  global() {
    return this.readAttributeUnderscore("global")
  }

  /** @returns {boolean} */
  hasGlobal() {
    const value = this.global()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  photoSheetProductSheetLayoutsCount() {
    return this.readAttributeUnderscore("photo_sheet_product_sheet_layouts_count")
  }

  /** @returns {boolean} */
  hasPhotoSheetProductSheetLayoutsCount() {
    const value = this.photoSheetProductSheetLayoutsCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  sheetLayoutId() {
    return this.readAttributeUnderscore("sheet_layout_id")
  }

  /** @returns {boolean} */
  hasSheetLayoutId() {
    const value = this.sheetLayoutId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./photo-sheet-product-box.js").default>} */
  photoSheetProductBoxes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_sheet_product_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "photo_sheet_product_boxes",
        model: this,
        modelClass: PhotoSheetProductBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-sheet-product-box.js").default>>} */
  loadPhotoSheetProductBoxes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_sheet_product_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "photo_sheet_product_boxes",
        model: this,
        modelClass: PhotoSheetProductBox
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-sheet-product-box.js").default>>} */
  ensurePhotoSheetProductBoxesLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product_boxes")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./photo-sheet-product-sheet-layout.js").default>} */
  photoSheetProductSheetLayouts() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_sheet_product_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "photo_sheet_product_sheet_layouts",
        model: this,
        modelClass: PhotoSheetProductSheetLayout
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-sheet-product-sheet-layout.js").default>>} */
  loadPhotoSheetProductSheetLayouts() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["photo_sheet_product_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "photo_sheet_product_sheet_layouts",
        model: this,
        modelClass: PhotoSheetProductSheetLayout
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./photo-sheet-product-sheet-layout.js").default>>} */
  ensurePhotoSheetProductSheetLayoutsLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product_sheet_layouts")
  }

  /** @returns {import("./sheet-layout.js").default | null} */
  sheetLayout() {
    return this._readBelongsToReflection({modelClass: SheetLayout, reflectionName: "sheet_layout"})
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  loadSheetLayout() {
    if (!("sheetLayoutId" in this)) throw new Error("Foreign key method wasn't defined: sheetLayoutId")

    const id = this.sheetLayoutId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "sheet_layout",
        model: this,
        modelClass: SheetLayout
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./sheet-layout.js").default | null>} */
  ensureSheetLayoutLoaded() {
    return this.ensureAssociationLoaded("sheet_layout")
  }

  /** @returns {import("./tenant.js").default | null} */
  tenant() {
    return this._readBelongsToReflection({modelClass: Tenant, reflectionName: "tenant"})
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  loadTenant() {
    if (!("tenantId" in this)) throw new Error("Foreign key method wasn't defined: tenantId")

    const id = this.tenantId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "tenant",
        model: this,
        modelClass: Tenant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./tenant.js").default | null>} */
  ensureTenantLoaded() {
    return this.ensureAssociationLoaded("tenant")
  }
}
